<template>
  <div class="checkboxes-container">
    <div
      v-for="item in items"
      :key="item.area_uuid"
      class="checkbox-item">
      <label
        :for="`checkbox-${item.area_uuid}`"
        :class="{'selected': isOptionSelected(item)}">
        <input
          class="sr-only"
          type="checkbox"
          :id="`checkbox-${item.area_uuid}`"
          v-bind="selectedOptions"
          :checked="isOptionSelected(item)"
          :value="item.area_uuid"
          :aria-label="item.area_label"
          @change="updateSelectedOptions(item)"
        >
        <slot v-if="isOptionSelected(item)" name="checked-icon"/>
        {{ item.area_label }}
        <span v-if="showIcons" class="chip-icon">&plus;</span>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChipsInput',
  props: {
    items: {
      type: Array,
      default: () => []
    },
    selectedOptions: {
      type: Array,
      default: () => []
    },
    showIcons: {
      type: Boolean,
      default: false
    },
  },
  methods: {
    isOptionSelected(option) {
      return this.selectedOptions.some(o => o.area_uuid === option.area_uuid)
    },
    updateSelectedOptions(option) {
      let newArr = [...this.selectedOptions]
      if (!this.isOptionSelected(option)) {
        newArr.push(option)
      } else {
        newArr = newArr.filter(obj => obj.area_uuid !== option.area_uuid)
      }
      this.$emit('input', newArr)
    }
  },
};
</script>

<style scoped lang="less">
@import '~@/variables.less';
input:focus-visible {
  outline: none; // label gets visible focus
}

.chip-icon {
  transition: 0.3s transform;
  font-size: 1.5rem;
  padding-left: .5rem;
  align-self: flex-start;
  line-height: .7rem;
}

label {
  border: 1px solid @gray-dark;
  border-radius: 8px;
  color: @gray-dark;
  font-size: 1.1rem;
  font-style: normal;
  font-weight: normal;
  padding: .5rem .75rem;
  line-height: 1rem;
  display: flex;
  align-items: center;
  &.selected {
    border-color: @plPurple;
    color: @plPurple;
    font-weight: bold;
    padding-right: .5rem;
    .chip-icon {
      transform: rotate(45deg);
      font-weight: normal;
      font-size: 1.9rem;
      line-height: .5rem;
    }
  }
  &:hover {
    cursor: pointer;
    background: lighten(@gray-light, 40%);
  }
  &:has(:focus-visible) {
    outline: 2px solid darken(@gray-dark, 10%);
  }
}
.checkboxes-container {
  display: flex;
  flex-wrap: wrap;
  padding-top: .5rem;
}
.checkbox-item {
  padding: 0 .5rem .5rem .5rem;
}

.select-icon {
  font-size: 1rem;
  margin-right: 0.5rem;
}
</style>
